import * as n from "react";
import { r as p } from "./index-DWGznc13.js";
import { S as f } from "./index-DK6lfaz2.js";
import { jsx as d } from "react/jsx-runtime";
var u = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], h = u.reduce((r, i) => {
  const o = n.forwardRef((t, e) => {
    const { asChild: s, ...a } = t, m = s ? f : i;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ d(m, { ...a, ref: e });
  });
  return o.displayName = `Primitive.${i}`, { ...r, [i]: o };
}, {});
function w(r, i) {
  r && p.flushSync(() => r.dispatchEvent(i));
}
export {
  h as P,
  w as d
};
